"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IUBODeclarationReason = void 0;
var IUBODeclarationReason;
(function (IUBODeclarationReason) {
    IUBODeclarationReason["WRONG_UBO_INFORMATION"] = "WRONG_UBO_INFORMATION";
    IUBODeclarationReason["MISSING_UBO"] = "MISSING_UBO";
    IUBODeclarationReason["UBO_IDENTITY_NEEDED"] = "UBO_IDENTITY_NEEDED";
    IUBODeclarationReason["DOCUMENTS_NEEDED"] = "DOCUMENTS_NEEDED";
    IUBODeclarationReason["SHAREHOLDERS_DECLARATION_NEEDED"] = "SHAREHOLDERS_DECLARATION_NEEDED";
    IUBODeclarationReason["ORGANIZATION_CHART_NEEDED"] = "ORGANIZATION_CHART_NEEDED";
    IUBODeclarationReason["DECLARATION_DO_NOT_MATCH_UBO_INFORMATION"] = "DECLARATION_DO_NOT_MATCH_UBO_INFORMATION";
    IUBODeclarationReason["SPECIFIC_CASE"] = "SPECIFIC_CASE";
})(IUBODeclarationReason || (exports.IUBODeclarationReason = IUBODeclarationReason = {}));
//# sourceMappingURL=IUBODeclarationReason.js.map